<template>
    <div class="attendance_admin_management_wrap">
        <ul class="custom-tabbar">
            <li v-for="(tabItem, tabIndex) in tabList" :key="tabIndex" @click="handleClickTab(tabItem.name)" :class="{ active: tabItem.name == activeName }">
                <span>{{ tabItem.label }}</span>
            </li>
        </ul>
        <div class="attendance_admin_management_content">
            <template v-if="activeName == 'attendanceGroup'">
                <AttendanceGroup />
            </template>
            <template v-else-if="activeName == 'holidayRule'">
                <AttendanceHolidayRule />
            </template>
            <template v-else-if="activeName == 'overtimeRule'">
                <OvertimeRule />
            </template>
            <template v-else>
                <HolidayBalance />
            </template>
        </div>
    </div>
</template>

<script>
import AttendanceGroup from './attendance_group.vue';
import AttendanceHolidayRule from "./attendance_holiday_rule.vue"
import OvertimeRule from "./overtime_rule.vue"
import HolidayBalance from "./holiday_balance.vue"
export default {
    name: "AttendanceAdminManagement",
    components: {
        AttendanceGroup,
        AttendanceHolidayRule,
        OvertimeRule,
        HolidayBalance
    },
    data() {
        return {
            activeName: "attendanceGroup",
            tabList: [
                {
                    name: "attendanceGroup",
                    label: "考勤组管理"
                },
                {
                    name: "holidayRule",
                    label: "假期规则"
                },
                {
                    name: "overtimeRule",
                    label: "加班规则"
                },
                {
                    name: "holidayBalance",
                    label: "员工假期余额"
                },
            ]
        }
    },
    created() {
        if(this.$route.params && this.$route.params.tab) {
            this.activeName = this.$route.params.tab
        }
    },
    methods: {
        handleClickTab(name) {
            this.activeName = name
        }
    }
}
</script>

<style lang="scss" scoped>
.attendance_admin_management_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .custom-tabbar {
        position: relative;
        padding: 0 16px;
        border-bottom: 1px solid #e8e8e8;
        flex-shrink: 0;

        li {
            display: inline-block;
            vertical-align: top;
            height: 48px;
            line-height: 48px;
            padding: 0 16px;
            position: relative;
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            cursor: pointer;

            &.active {
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                color: rgba(41, 144, 255, 1);

                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    width: 100%;
                    bottom: 0;
                    height: 2px;
                    opacity: 1;
                    background: #2990ff;
                }
            }
        }
    }
    .attendance_admin_management_content {
        flex: 1;
    }
}
</style>